























































import { Vue, Prop, Component } from "vue-property-decorator";
import { archiveActions } from "@/utils/document-archive";
import Modal from "@/components/form/Modal.vue";

@Component({
  components: { Modal }
})
export default class DocumentArchiveButton extends Vue {
  @Prop({ default: false }) isArchive?: boolean;
  @Prop() entity!:
    | "contract"
    | "act"
    | "bill"
    | "enrollmentOrder"
    | "expulsionOrder"
    | "educationProtocol"
    | "finalDocument";
  @Prop() id!: string;
  isLoading?: boolean = false;

  async action() {
    const method = async (id: string) => {
      return this.isArchive
        ? archiveActions.remove[this.entity](id)
        : archiveActions.add[this.entity](id);
    };

    try {
      this.isLoading = true;
      const response = await method(this.id);
      this.$emit("state", response.data.archive);
      await this.$store.dispatch("successToast", {
        message: this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved)
      });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }
}
